module.exports = __webpack_public_path__ + "img/30_26.5d094902.png";